import { SearchIndexQuery } from '@/components/ui/features/schedule/ScheduleQuerySearch/SearchIndexQuery';
import { LectureSearchResults } from '@/components/ui/features/schedule/ScheduleSearchResult/LectureSearchResults';
import { EventSessions } from '@/containers/Event/EventSessions';
import { EventSpeakers } from '@/containers/Event/EventSpeakers';
import { SearchCategories, SearchGroup } from '@/enums';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const SearchQuery = () => {
  const { searchGroup } = useQueryParams<{ searchGroup: SearchGroup }>({
    searchGroup: StringParam,
  });

  if (!searchGroup || searchGroup === SearchGroup.ALL) return <SearchIndexQuery />;

  if (searchGroup === SearchGroup.EVENT_SESSION) return <EventSessions scope={SearchCategories.LECTURES} />;
  if (searchGroup === SearchGroup.SPEAKERS) return <EventSpeakers />;
  if (searchGroup === SearchGroup.LECTURE) return <LectureSearchResults />;
};
